import React from 'react';
import ReactMarkdown from 'react-markdown';
import { useSelector } from 'react-redux';

import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  img {
    width: 100%;
  }

  h1, h2, h3, h4, h5 {
    margin-top: 0;
  }
`;
const ScrollContainer = styled.div`
  padding: 0 16px 16px 0;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
`;

const mapState = ({
  information,
}) => ({
  information,
});

export const Information = () => {
  const {
    information,
  } = useSelector(
    mapState,
  );

  return (
    <Container>
      <ScrollContainer>
        <ReactMarkdown>{information}</ReactMarkdown>
      </ScrollContainer>
    </Container>
  );
};
